import { styled } from '@material-ui/core'

const DescArticle = ({ producto }) => {
  return (
    <div style={{ marginTop: '10px'}}>
        <Marca>{ producto.Marca.toUpperCase() }</Marca>
        <Producto>{ producto.Descripcion.toCapitalize() }</Producto>
        <Precio>Precio Unitario { producto.PrecioNormal?.toCurrency() }</Precio>
    </div>
  )
}

const Marca = styled('div')({
    fontWeight: '600',
    fontSize: '9px',
    lineHeight: '11px',
    display: 'flex',
    alignItems: 'center',
    color: '#aaaaaa',
    marginBottom: '6px',
    fontFamily: 'Inter'
});

const Producto = styled('div')({
    fontWeight: '500',
    fontSize: '12px',
    margin: 0,
    padding: 0,
    lineHeight: '15px',
    letterSpacing: '-0.035em',
    color: '#46474a',
    marginBottom: '6px',
    fontFamily: 'Inter'
});

const Precio = styled('div')({
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '15px',
    letterSpacing: '-0.035em',
    color: '#a8a8a8',
    fontFamily: 'Inter,sans-serif',
});

export default DescArticle
